<template>
    <div>
        <div @click="showSellingThread(buyer.buyerId, itemId)" v-for="(buyer, i) in buyers" :key="i" class="row pt-3 message-contacts">
            <div class="col-md-2 text-center contact-message-photo-con">
                <img v-if="buyer.photo" :src="userMainPhoto(buyer.photo)" class="contact-message-photo rounded-circle pt-1" :alt="`${buyer.name} aNewItem's profile`">
                <i v-else class="far fa-user-circle fa-2x pt-1"></i>
            </div>
            <div class="col-md-10 col-12 contact-message-name-con">
                <p class="font-weight-bold m-0 text-capitalize">
                    {{buyer.name}} <span v-if="buyer.unreadMsg > 0" class="badge badge-warning">{{buyer.unreadMsg}}</span>
                </p>
                <p class="text-muted text-truncate m-0">{{buyer.lastMsg}}</p>
                <hr class="m-0">
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { appendImgHostUrl } from '@/store/dry'

export default {
    name: "Contacts",
    props:  ['buyers', 'itemId'],
    methods: {
        ...mapActions(['fetchMsgThread']),
        userMainPhoto(path) {
            if(!path) return ''
            return appendImgHostUrl(path)
        },
        showSellingThread(buyerId, itemId) {
            let threadObj = {
                sellerId: this.user._id,
                buyerId: buyerId,
                itemId: itemId,
                receiverId: this.user._id
            }
            this.fetchMsgThread(threadObj)
        },
    },
    computed: {
        ...mapGetters(['user'])
    }
}
</script>